import React from "react";
import themeStyles from "../../shared/styles/theme/theme-styles.module.scss";
import styles from "./styles.module.scss";
import InputGroup from "../components/inputGroup/InputGroup";

const ProfileForm = (props) => {
  const handleSubmit = async (e, values) => {
    e.preventDefault();
    await props.setTouched(
      Object.keys(values).reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
      }, {}),
      true
    );

    if (
      Object.keys(props.touched).length > 0 &&
      !Object.keys(props.errors).length > 0
    ) {
      props.handleSubmit(values);
    }
  };

  const { errors, handleChange, handleBlur, touched, values } = props;

  const { name, lastName, email } = values;

  return (
    <div className={styles.containerForm}>
      <form>
        <fieldset className={styles.field}>
          <label className={styles.title}>{"Your Profile"}</label>
          <div className={styles.section}>
            <div className={styles.column}>
              <InputGroup
                name="name"
                label={"First Name"}
                leftMargin={false}
                touched={touched}
                errors={errors}
                onBlur={handleBlur}
                inputValue={name}
                onChange={handleChange}
                className={styles.input}
              />
            </div>
            <div className={styles.column}>
              <InputGroup
                name="lastName"
                label={"Last Name"}
                leftMargin={false}
                touched={touched}
                errors={errors}
                onBlur={handleBlur}
                inputValue={lastName}
                onChange={handleChange}
                className={styles.input}
              />
            </div>
            <div className={styles.column}>
              <InputGroup
                name="email"
                label={"Email"}
                leftMargin={false}
                touched={touched}
                errors={errors}
                onBlur={handleBlur}
                inputValue={email}
                onChange={handleChange}
                className={styles.input}
              />
            </div>
          </div>
        </fieldset>
        <div className={styles.buttonRow}>
          <button
            className={`${themeStyles.btnPrimaryLT}`}
            type="submit"
            onClick={(e) => handleSubmit(e, values)}
          >
            {"Save"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProfileForm;
